import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

const navStyle = ({ isActive }: { isActive: boolean }) => ({
  display: 'block',
  padding: '10px 16px',
  borderRadius: 6,
  marginBottom: 4,
  color: isActive ? '#fff' : '#374151',
  background: isActive ? '#1a1a1a' : 'transparent',
  fontSize: 14,
  fontWeight: 500 as const,
});

export function Layout() {
  const navigate = useNavigate();
  const logout = async () => {
    try {
      await api.post('/api/admin/auth/logout');
    } catch {}
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside
        style={{
          width: 240,
          background: '#fff',
          borderRight: '1px solid #e5e5e5',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h1
          style={{
            margin: '0 0 32px',
            fontFamily: 'Georgia, serif',
            fontSize: 18,
            letterSpacing: 2,
            textTransform: 'uppercase',
            fontWeight: 400,
          }}
        >
          Lumina Admin
        </h1>
        <nav style={{ flex: 1 }}>
          <NavLink to="/" end style={navStyle}>
            Dashboard
          </NavLink>
          <NavLink to="/orders" style={navStyle}>
            Orders
          </NavLink>
          <NavLink to="/customers" style={navStyle}>
            Customers
          </NavLink>
          <NavLink to="/photos" style={navStyle}>
            Photos
          </NavLink>
        </nav>
        <button
          onClick={logout}
          style={{
            padding: '10px 16px',
            border: '1px solid #e5e5e5',
            background: '#fff',
            cursor: 'pointer',
            borderRadius: 6,
            color: '#6b7280',
            fontSize: 14,
          }}
        >
          Sign Out
        </button>
      </aside>
      <main style={{ flex: 1, padding: 40, maxWidth: 1200 }}>
        <Outlet />
      </main>
    </div>
  );
}
